import { apiRequest } from '../../../shared/services/apiClient';
import type { AiPromptUseCaseId } from '../../admin/types/AiPromptConfig';

export async function getToolUseCaseAssignments(functionId: string): Promise<AiPromptUseCaseId[]> {
  const encodedFunctionId = encodeURIComponent(functionId);
  const result = await apiRequest<{ useCaseIds?: string[] }>(
    `/api/v1/settings/ai/tool-functions/${encodedFunctionId}/use-cases`,
    { method: 'GET' },
  );

  return Array.isArray(result.useCaseIds) ? result.useCaseIds as AiPromptUseCaseId[] : [];
}
